import * as jQuery from 'jquery';
import { Analytics } from '@plaudit/analytics';

export default class Gallery {
	constructor() {
		const selector_gallery = '.gallery';
		const selector_viewer = '.gallery__view';
		const selector_thumbs = '.gallery__thumb';
		const selector_thumbsContainer = '.gallery__thumbsInner';
		const selector_media = '.image';
		const selector_counter = '.gallery__counter';

		let $gallery = jQuery(selector_gallery);
		if ($gallery.length === 0) {
			return;
		}

		const analytics = Analytics.getInstance();
		const trackControlEvent = (label: string) => analytics.trackEvent('Image Gallery', 'Control Click', label);

		$gallery.each((index, element) => {
			let currentIndex = 0;
			let removeOldMediaTimeoutID: number = undefined;
			const $elem = jQuery(element);
			const $galleryView = $elem.find(selector_viewer);
			const $galleryThumbs = $elem.find(selector_thumbs);
			function removeOldMedia(): void {
				// Remove all but first one
				let $mediaElements = $galleryView.find(selector_media);
				for (let i=1; i < $mediaElements.length; ++i) {
					jQuery($mediaElements[i]).remove();
				}
				$galleryView.attr('status', '');

				removeOldMediaTimeoutID = undefined;
			}

			/**
			 * Activates selected and deactivates others
			 * @param {number} newIndex The index of the slide to activate
			 */
			function activateByIndex(newIndex: number): void {
				currentIndex = newIndex;

				const $thumb = jQuery($galleryThumbs[newIndex]);
				const $image = $thumb.find('a.image');
				const $video = $thumb.find('a.video');
				const imageHref = $image.attr('href');
				const $galleryMedia = $galleryView.find(selector_media);

				// check if user has clicked on currently active index
				if ($galleryMedia.attr('src') !== imageHref) {
					if (removeOldMediaTimeoutID !== undefined) {
						clearTimeout(removeOldMediaTimeoutID);
					}

					// Remove 'active' class from all thumbnails and then add to current
					$galleryThumbs.attr('status', '');
					$thumb.attr('status', 'active');

					// Load the new media
					$galleryView.attr('status', 'loading');
					let alt = $image.find('img').attr('alt') || ' ';

					const newImageParts = [];
					newImageParts.push(`<div class="${ $image.attr('class') }" style="background-image: url(${ imageHref });" imageStyle="${ ($image.attr('imageStyle') || '') }">`);
					newImageParts.push(`<img src="${ imageHref }" alt="${ alt }" />`);
					newImageParts.push(`</div>`);
					const newImage = newImageParts.join('');

					$galleryView.prepend(jQuery(newImage));

					// Have media removing removed once done
					removeOldMediaTimeoutID = window.setTimeout(removeOldMedia, 1000);
				}
			}

			function setCounter() {
				const $counter = $gallery.find(selector_counter);
				
				$counter.find('[class$="--count"]').text(1);

				const total = $gallery.find(selector_thumbs).children().length;
				$counter.find('[class$="--total"]').text(total);
			}
			function updateCount(newIndex: number): void {
				const $counter = $gallery.find(selector_counter);
				$counter.find('[class$="--count"]').text(newIndex + 1);
			}

			function moveToActiveThumb() {
				var translateDelta;

				var thumbs = document.querySelector('.gallery__thumbs');
				var thumbActive = document.querySelector('[status="active"]');

				var thumbsRect = thumbs.getBoundingClientRect();
				var thumbActiveRect =  thumbActive.getBoundingClientRect();

				// check if active thumb is outside container (not in full view)
				if (thumbActiveRect.left < thumbsRect.left) {
					// thumb is on the left side of the container
					translateDelta = thumbsRect.left - thumbActiveRect.left;
				} else if (thumbActiveRect.right > thumbsRect.right) {
					// thumb is on the right side of the container
					translateDelta = thumbsRect.right - thumbActiveRect.right;
				} else {
					// thumb is fully within view
					return;
				}

				updateTranslateX(thumbsTranslationX + translateDelta);
			}

			// Set up thumbnail clicks
			function thumbClickHandler(event: JQueryMouseEventObject): void {
				event.preventDefault();
				
				const newIndex = jQuery(this).parent(selector_thumbs).index();
				activateByIndex(newIndex);
				updateCount(newIndex);
				moveToActiveThumb();

				trackControlEvent('Thumbnail');
			}
			$galleryThumbs.on('click', 'a', thumbClickHandler);

			/////// THUMBS CONTROLERS ///////
			const thumbsContainer = document.querySelector(selector_thumbsContainer);
			var thumbsContainerWidth : number;
			var thumbWidth : number;
			var thumbsTotalWidth : number;
			var thumbsTranslationX = 0;

			function updateThumbWidths() {
				thumbsContainerWidth = thumbsContainer.getBoundingClientRect().width;
				thumbWidth = parseInt(window.getComputedStyle($galleryThumbs[0]).width,10);
				// includes width of overflowing content
				thumbsTotalWidth = thumbWidth * $galleryThumbs.length;
			}
			// set display for each JQuery object in an array: 'block' if true, 'none' if false
			function setButtonDisplay(buttons : Array<JQuery>, condition: boolean) {
				buttons.forEach(function(button) {
					if (condition) {
						button.css('display', 'block');
					} else {
						button.css('display', 'none');
					}
				});
			}
			function updateTranslateX(translationX: number) {
				thumbsTranslationX = translationX;
				jQuery(thumbsContainer).css("transform", "translateX(" + thumbsTranslationX + "px)");

				return thumbsTranslationX;
			}
			function clickHandler_Thumbs(event: JQuery.Event, type: string) {
				var newVal;
				var oldVal = thumbsTranslationX;

				// set up default translation value
				var thumbNum = thumbsContainerWidth / thumbWidth;
				// integer number of thumb widths to translate by
				var thumbInt = Math.max(Math.floor(thumbNum) - 1, 1);
				// translate to the inner edge of the first fully visible image
				var changeDefault = thumbInt * thumbWidth;

				// set up boundary conditions
				const translationMin = thumbsContainerWidth - thumbsTotalWidth;
				const translationMax = 0;
				// constrain translation value so thumbs don't translate out of range
				if (type === 'previous') {
					newVal = oldVal + changeDefault;
					if (newVal > translationMax) {
						newVal = translationMax;
					}
				} else if (type === 'next') {
					newVal = oldVal - changeDefault;
					if (newVal < translationMin) {
						newVal = translationMin;
					}
				}

				updateTranslateX(newVal);
			}

			/////// VIEW CONTROLERS ///////
			function prevClickHandler_View(event: JQueryMouseEventObject) {
				const newIndex = currentIndex
					? currentIndex - 1
					: $galleryThumbs.length - 1;

				activateByIndex(newIndex);
				updateCount(newIndex);
				moveToActiveThumb();
				trackControlEvent('Previous');
			}
			function nextClickHandler_View(event: JQueryMouseEventObject) {
				const newIndex = currentIndex < $galleryThumbs.length - 1
					? currentIndex + 1
					: 0;

				activateByIndex(newIndex);
				updateCount(newIndex);
				moveToActiveThumb();
				trackControlEvent('Next');
			}


			/////// SET UP CONTROLLER HANDLERS ///////
			function createControlHandlers(selector : string) {
				const $prevEl = $elem.find('button[class*="--prev"][class*="--' + selector + '"]');
				const $nextEl = $elem.find('button[class*="--next"][class*="--' + selector + '"]');
				
				if (selector === 'view') {
					$prevEl.on('click', prevClickHandler_View);
					$nextEl.on('click', nextClickHandler_View);
				} else if (selector === 'thumbs') {
					// set initial widths and button displays
					updateThumbWidths();
					// hide or show buttons depending on whether thumbs are entirely inside container or not
					setButtonDisplay([$prevEl, $nextEl], (thumbsTotalWidth > thumbsContainerWidth ? true : false));

					// update widths and button displays on resize
					window.addEventListener("resize", function() {
						updateThumbWidths();
						setButtonDisplay([$prevEl, $nextEl], (thumbsTotalWidth > thumbsContainerWidth ? true : false));
					});

					$prevEl.on('click', event => clickHandler_Thumbs(event, 'previous'));
					$nextEl.on('click', event => clickHandler_Thumbs(event, 'next'));
				}
			}
			createControlHandlers('view');
			createControlHandlers('thumbs');
			setCounter();
		});
	}
}